import React, { useEffect, useState } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { withRouter } from "react-router-dom";
import Landing from "../Parts/Landing/Landing";
import "./index.css";
import "../Parts/Pages/pages.css";
import AboutUs from "../Parts/Pages/AboutUs";
import Careers from "../Parts/Pages/Careers";
import PrivacyPolicy from "../Parts/Pages/PrivacyPolicy";
import TermsOfService from "../Parts/Pages/TermsOfService";
import ClientAgreement from "../Parts/Pages/ClientAgreement";
import CookiePolicy from "../Parts/Pages/CookiePolicy";

const BasePage = () => {
  const [isDesktop, setIsDesktop] = useState(0);
  const [popUpVisible, setPopUpVisible] = useState(false);

  useEffect(() => {
    screenSizeDetector();
    window.addEventListener("resize", screenSizeDetector);
  }, []);

  const screenSizeDetector = () => {
    if (window.innerWidth > 900 && window.innerWidth < 1000) {
      setIsDesktop(true);
    } else if (window.innerWidth <= 900) {
      setIsDesktop(false);
    } else {
      setIsDesktop(true);
    }
  };

  return (
    <>
      <ScrollToTop />

      <Switch>
        <Route exact path="/" component={Landing} />
        <Route exact path="/about" component={AboutUs} />
        <Route exact path="/careers" component={Careers} />
        <Route exact path="/privacy" component={PrivacyPolicy} />
        <Route exact path="/terms" component={TermsOfService} />
        <Route exact path="/agreement" component={ClientAgreement} />
        <Route exact path="/cookies" component={CookiePolicy} />
        <Redirect to="/" />
      </Switch>
    </>
  );
};

export default withRouter(BasePage);
